// Import Swiper core and required modules
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./css/test.css";
import mamakaba from "./imgs/mamakaba.webp";
import arsen from "./imgs/arsene.jpg";
import reponse from "./imgs/Reponse.jpg";

// Testimonial Card Component
function TestimonialCard({ quote, author, role, imgSrc }) {
  return (
    <div className="max-w-screen-xl mx-auto bg-white rounded-lg shadow-lg">
      <figure className="mt-10">
        <blockquote className="text-center text-xl font-semibold leading-8 text-gray-900 sm:text-2xl sm:leading-9">
          <p>{quote}</p>
        </blockquote>
        <figcaption className="mt-10">
          <div className="flex justify-center items-center space-x-8">
            <div className="w-32 h-32 justify-center items-center flex overflow-hidden">
              <img alt="" src={imgSrc} className="userImage" />
            </div>
            <div className="mt-4 flex items-center justify-center space-x-3 text-base">
              <div className="font-semibold text-gray-900">{author}</div>
              <svg
                width={3}
                height={3}
                viewBox="0 0 2 2"
                aria-hidden="true"
                className="fill-gray-900"
              >
                <circle r={1} cx={1} cy={1} />
              </svg>
              <div className="text-gray-600">{role}</div>
            </div>
          </div>
        </figcaption>
      </figure>
    </div>
  );
}

// Main Testimonials Component
export default function Testimonials() {
  const testimonials = [
    {
      quote: "“Batanga Service inoze pee!”",
      author: "Maman Kabalisa",
      role: "Client",
      imgSrc: mamakaba,
    },
    {
      quote:
        "“The Grand Shop makes professional websites. If you also consider the quality, before anything else, I recommend you order now!”",
      author: "Arsene",
      role: "Developer",
      imgSrc: arsen,
    },
    {
      quote:
        "“The Grand Shop offers impeccable, comprehensive services with outstanding quality and convenience. You go and see it for yourselves, guys!”",
      author: "Reponse",
      role: "Customer",
      imgSrc: reponse,
    },
    // Add more testimonials here
  ];

  return (
    <section className="max-w-screen-xl mx-auto overflow-hidden bg-white px-6 my-6 mx-2 lg:px-8 h-96 ">
      <h2
        style={{ color: "#3A636C" }}
        className="text-center font-semibold text-4xl p-8"
      >
        {" "}
        Testimonies
      </h2>
      <div className="p-4 w-full">
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          pagination={{ clickable: true }}
          loop={true}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <TestimonialCard
                quote={testimonial.quote}
                author={testimonial.author}
                role={testimonial.role}
                imgSrc={testimonial.imgSrc}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
